<template>
    <div class="wf-field">
        <label class="wf-label">
            {{ label }} <span v-if="isRequired" class="wf-required">*</span>
        </label>
        <p v-if="instruction" class="wf-instruction">{{ instruction }}</p>
        <input
            :type="inputType"
            :value="value"
            class="wf-input"
            :class="{ 'wf-input--error': error }"
            :placeholder="label"
            @input="emitValue($event.target.value)"
        />
        <p v-if="help" class="wf-help">{{ help }}</p>
    </div>
</template>

<script>
import FieldMixin from './FieldMixin'
import { getFieldInputType } from '../fieldRegistry'

export default {
    name: 'TextField',
    mixins: [FieldMixin],
    computed: {
        inputType() {
            return getFieldInputType(this.attribute.form_attribute_type_id) || 'text'
        }
    }
}
</script>
